<template>
  <Loader v-if="showLoader"/>
  <div class="wrapper" v-show="!showLoader">
    <Header/>
    <div class="content callcenter__layout">
      <slot/>
    </div>
  </div>
</template>
<script setup lang="ts">
import Header from "~/components/callcenter/Header.vue";
import {useFMStore} from "~/store/FMStore";
import Loader from "~/components/Loader.vue";
import {watch, ref} from "vue";

const FMStore = useFMStore();
const showLoader = ref(true);
let timeoutId = null;

watch(
    () => FMStore.loading,
    (newValue) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      if (newValue) {
        showLoader.value = true;
      } else {
        timeoutId = setTimeout(() => {
          showLoader.value = false;
        }, 500);
      }
    },
    {immediate: true}
);
</script>

<style lang="scss">
.wrapper {
  height: 100dvh;
  display: flex;
  flex-direction: column;
  background-color: white;

  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    & > div {
      flex-grow: 1;
    }
  }


}

.container {
  width: 100%;
  max-width: 864px;
  margin: 0 auto;
  height: fit-content;
}
.callcenter__layout {
  .buttons__block{
    padding-bottom: 16px;
    background-color: white;
  }
}
</style>
